import React from 'react';
import styles from './Formulario.module.css';
import useSelect from '../hooks/useSelect';
import PropTypes from 'prop-types';


const Formulario = ({guardarCategoria}) => {

    //opciones
    const OPCIONES=[
        {value:'general',label:'General'},
        {value:'business',label:'Negocios'},
        {value:'entertainment',label:'Entretenimiento'},
        {value:'health',label:'Salud'},
        {value:'science',label:'Ciencia'},
        {value:'sports',label:'Deportes'},
        {value:'technology',label:'Tecnología'}
    ]


    //utilizo custom hook
    const[categoria,SelectNoticias]=useSelect('general',OPCIONES);

    //submit del form
    const buscarNoticia=e=>{
        e.preventDefault();

        guardarCategoria(categoria);
    }



    return ( 
        <div className={`${styles.buscador} row`}> 
                    <h2 className={styles.heading}>Encuentra Noticias por Categoría</h2>

            <div className="col s12 m8 offset-m2">
                <form
                    onSubmit={buscarNoticia}
                >

                        <SelectNoticias/>

                        <div className="input-field col s12">
                            <input 
                            type="submit"
                            className={`waves-effect waves-light ${styles.btn_block} btn-large amber darken-2`}
                            value="Buscar"
                            />
                    </div>
                </form>
            </div>
        </div>
     );
}
Formulario.propTypes={
    guardarCategoria:PropTypes.func.isRequired
}
 
export default Formulario;